import type { EntityRegistry } from '@sites/entity-migrator';

import { DefaultGridEntitySchema, type GridEntity } from './schemas';

export const gridRegistry: EntityRegistry<GridEntity> = {
    name: 'grid',
    getEntitySchema: (entity: unknown) => {
        if (typeof entity !== 'object' || entity === null) return null;
        const { entitySubType, version } = entity as { entitySubType?: unknown; version?: unknown };
        if (entitySubType === 'default') return DefaultGridEntitySchema;
        // pre-versioning grids carry neither subtype nor version; all of them are 'default'
        if (entitySubType === undefined && version === undefined) return DefaultGridEntitySchema;
        return null;
    },
};
